import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { Field } from '@tsim/model';

export class ProjectEntity extends BaseRootEntity {
  @Field(Date, true)
  completionDate!: Date;

  @Field(String, true)
  title!: string;

  @Field(String, false)
  description?: string;

  @Field(String, true)
  location!: string;

  @Field(String, false)
  device?: string;

  @Field([String], false)
  tags?: string[] = [];

  @Field([String], true)
  gallery: string[] = [];
}
